// import { Routes, Route, Outlet, Router } from "react-router-dom";

// import Header from "./components/header.js";
// import Footer from "./components/footer.js";
import UserProvider from './providers/user-provider.js'
import RoutesContainer from './Routes.js'
import React from 'react'
import { BrowserRouter } from 'react-router-dom'

export default function App() {
  return (
    <UserProvider>
      <BrowserRouter>
        <RoutesContainer /> 
      </BrowserRouter>
    </UserProvider>
  );
}